import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cheapestcabserviceinmumbai() {



    const cardData = {





keyword: "Cheapest Cab Service in Mumbai",

headingDescription: "Shreesha Tours & Travels offers the Cheapest Cab Service in Mumbai with affordable pricing, reliable transportation, and premium travel comfort for every journey. We provide budget-friendly cab services for airport transfers, corporate travel, family vacations, business meetings, local sightseeing, outstation trips, one-way travel, round trips, and wedding transportation. Choose from our fleet of Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, Mini Bus, and luxury vehicles, all driven by experienced chauffeurs. With transparent fares, no hidden charges, doorstep pickup and drop, well-maintained vehicles, flexible booking options, and 24/7 customer support, Shreesha Tours & Travels ensures economical, safe, and comfortable travel across Mumbai and beyond. Whether you're planning a short city ride or a long-distance road trip, we deliver value-for-money cab services with complete customer satisfaction.",

topPlaces: [
  {
    title: "Mumbai to Lonavala",
    description: "Lonavala is a favorite weekend destination known for Tiger Point, Bhushi Dam, Karla Caves, scenic valleys, and pleasant weather throughout the year."
  },
  {
    title: "Mumbai to Shirdi",
    description: "Shirdi is one of India's most visited pilgrimage destinations, attracting millions of devotees to the Sai Baba Samadhi Temple and nearby spiritual attractions."
  },
  {
    title: "Mumbai to Alibaug",
    description: "Alibaug is a popular beach destination offering Kolaba Fort, Alibaug Beach, Varsoli Beach, water sports, and relaxing coastal resorts."
  },
  {
    title: "Mumbai to Mahabaleshwar",
    description: "Mahabaleshwar is renowned for Venna Lake, Mapro Garden, strawberry farms, scenic viewpoints, and refreshing hill station weather."
  },
  {
    title: "Mumbai to Nashik",
    description: "Nashik is famous for Trimbakeshwar Jyotirlinga, Panchavati, vineyards, temples, and cultural attractions, making it a popular outstation destination."
  },
  {
    title: "Mumbai to Ganpatipule",
    description: "Ganpatipule is known for its Swayambhu Ganpati Temple, pristine beaches, Konkan coastline, and peaceful holiday atmosphere."
  },
  {
    title: "Mumbai to Aurangabad",
    description: "Aurangabad is home to Ajanta Caves, Ellora Caves, Daulatabad Fort, Bibi Ka Maqbara, and Grishneshwar Jyotirlinga."
  },
  {
    title: "Mumbai to Kolhapur",
    description: "Kolhapur is a historic city famous for Mahalaxmi Temple, Panhala Fort, Rankala Lake, and authentic Maharashtrian cuisine."
  },
  {
    title: "Mumbai to Tarkarli",
    description: "Tarkarli is a beautiful coastal destination offering scuba diving, snorkeling, Sindhudurg Fort, white-sand beaches, and crystal-clear waters."
  },
  {
    title: "Mumbai to Bhandardara",
    description: "Bhandardara is a scenic hill getaway known for Arthur Lake, Randha Waterfall, Wilson Dam, and tranquil natural surroundings."
  }
],


"services": [
  {
    "name": "Cheapest Cab Service in Mumbai",
    "description": "Book Cheapest Cab Service in Mumbai with affordable fares, transparent pricing, experienced chauffeurs, and well-maintained AC vehicles. Choose from Hyundai Aura, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, Sedan, SUV, Tempo Traveller, and luxury cabs for local, airport, corporate, family, and outstation travel."
  },
  {
    "name": "Cheapest Taxi Service in Mumbai",
    "description": "Choose Cheapest Taxi Service in Mumbai for budget-friendly travel with professional drivers, clean vehicles, punctual pickups, and comfortable rides across Mumbai and nearby destinations."
  },
  {
    "name": "Cheapest Cab from Mumbai to Nashik",
    "description": "Book the Cheapest Cab from Mumbai to Nashik for affordable one-way and round-trip travel with experienced chauffeurs, AC vehicles, and transparent pricing."
  },
  {
    "name": "Cheapest Cab in Mumbai",
    "description": "Reserve the Cheapest Cab in Mumbai for reliable transportation with economical fares, verified drivers, and comfortable vehicles available 24x7."
  },
  {
    "name": "Cheap Taxi in Mumbai",
    "description": "Hire Cheap Taxi in Mumbai for convenient local, airport, and outstation travel with affordable pricing, clean vehicles, and courteous chauffeurs."
  },
  {
    "name": "Cheap Cabs Mumbai",
    "description": "Book Cheap Cabs Mumbai for cost-effective transportation with multiple vehicle options, professional drivers, and dependable service."
  },
  {
    "name": "Cheap Taxi Mumbai",
    "description": "Choose Cheap Taxi Mumbai for comfortable rides with affordable fares, punctual service, and well-maintained AC vehicles."
  },
  {
    "name": "Cheapest Cab from Pune to Mumbai Airport",
    "description": "Reserve the Cheapest Cab from Pune to Mumbai Airport for timely airport transfers with comfortable vehicles, experienced drivers, and transparent pricing."
  },
  {
    "name": "Cheapest Outstation Cabs from Mumbai",
    "description": "Book Cheapest Outstation Cabs from Mumbai for one-way and round-trip journeys across Maharashtra and India with budget-friendly fares and reliable chauffeurs."
  },
  {
    "name": "Cheapest Cab Service in Mumbai Near Me",
    "description": "Find the Cheapest Cab Service in Mumbai Near Me with instant booking, fast pickups, affordable fares, and professional chauffeur-driven vehicles."
  },
  {
    "name": "Best Cheap Cab Service in Mumbai",
    "description": "Choose the Best Cheap Cab Service in Mumbai for quality travel, affordable pricing, experienced drivers, and premium customer support."
  },
  {
    "name": "Cheapest Taxi Mumbai Contact Number",
    "description": "Contact Cheapest Taxi Mumbai for instant cab booking, quick assistance, affordable fares, and reliable taxi services available throughout the day."
  },
  {
    "name": "Book Cheapest Cab in Mumbai Online",
    "description": "Book Cheapest Cab in Mumbai Online with instant confirmation, secure reservations, multiple vehicle options, and transparent pricing."
  },
  {
    "name": "Cheapest Cab Mumbai to Pune",
    "description": "Reserve the Cheapest Cab Mumbai to Pune for comfortable one-way and round-trip travel with affordable rates and experienced chauffeurs."
  },
  {
    "name": "Cheapest Cab Mumbai Airport Pickup",
    "description": "Book Cheapest Cab Mumbai Airport Pickup for punctual airport arrivals with flight tracking, luggage assistance, and affordable airport transfers."
  },
  {
    "name": "Cheapest Cab Service Mumbai 24x7",
    "description": "Choose Cheapest Cab Service Mumbai 24x7 for round-the-clock transportation with reliable drivers, AC vehicles, and economical pricing."
  },
  {
    "name": "Affordable Cab Service Mumbai for Family",
    "description": "Book Affordable Cab Service Mumbai for Family with spacious vehicles including Ertiga, Innova, Innova Crysta, Kia Carens, and SUVs for comfortable group travel."
  },
  {
    "name": "Cheap Cab Service Mumbai for Outstation",
    "description": "Reserve Cheap Cab Service Mumbai for Outstation trips with transparent fares, professional chauffeurs, and comfortable long-distance travel."
  },
  {
    "name": "Lowest Price Taxi Service in Mumbai",
    "description": "Choose Lowest Price Taxi Service in Mumbai for affordable local, airport, and outstation transportation without compromising comfort or safety."
  },
  {
    "name": "Mumbai to 5 Jyotirlinga Darshan Cab",
    "description": "Book Mumbai to 5 Jyotirlinga Darshan Cab for a comfortable religious tour with experienced chauffeurs, premium vehicles, and customized travel packages."
  },
  {
    "name": "Mumbai to Goa Cab",
    "description": "Reserve Mumbai to Goa Cab for one-way and round-trip travel with comfortable AC vehicles, professional drivers, and affordable pricing."
  },
  {
    "name": "Mumbai to Goa Taxi Fare",
    "description": "Get affordable Mumbai to Goa Taxi Fare with transparent pricing, multiple vehicle options, and reliable chauffeur-driven travel."
  },
  {
    "name": "Mumbai to Goa Taxi One Way Fare",
    "description": "Check Mumbai to Goa Taxi One Way Fare for economical drop taxi services with comfortable vehicles and professional chauffeurs."
  },
  {
    "name": "Mumbai to Goa Cab Price",
    "description": "Compare Mumbai to Goa Cab Price and choose from Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and luxury cab options."
  },
  {
    "name": "Cheapest Cab Service in Andheri",
    "description": "Book Cheapest Cab Service in Andheri for local rides, airport transfers, and outstation journeys with affordable pricing and reliable chauffeurs."
  },
  {
    "name": "Cheapest Cab Service in Navi Mumbai",
    "description": "Choose Cheapest Cab Service in Navi Mumbai for budget-friendly transportation with clean AC vehicles and experienced drivers."
  },
  {
    "name": "Cheapest Cab Service in Thane",
    "description": "Reserve Cheapest Cab Service in Thane for affordable local and outstation travel with professional chauffeur-driven vehicles."
  },
  {
    "name": "Cheapest Cab Service in Borivali",
    "description": "Book Cheapest Cab Service in Borivali for economical travel with punctual pickups, transparent fares, and comfortable AC vehicles."
  },
  {
    "name": "Cheapest Cab Service in Dadar",
    "description": "Choose Cheapest Cab Service in Dadar for affordable transportation with experienced drivers, clean vehicles, and reliable service."
  },
  {
    "name": "Cheapest Cab Service in Bandra",
    "description": "Reserve Cheapest Cab Service in Bandra for local, airport, and outstation travel with affordable pricing and premium comfort."
  },
  {
    "name": "Cheapest Cab Service in Kurla",
    "description": "Book Cheapest Cab Service in Kurla for convenient transportation with verified chauffeurs, AC vehicles, and economical fares."
  },
  {
    "name": "Cheapest Cab Service in Vashi",
    "description": "Choose Cheapest Cab Service in Vashi for budget-friendly rides with comfortable vehicles and dependable chauffeur-driven service."
  },
  {
    "name": "Cheapest Cab Service in Panvel",
    "description": "Reserve Cheapest Cab Service in Panvel for affordable airport transfers, local travel, and outstation journeys with experienced drivers."
  },
  {
    "name": "Cheapest Cab Service in Powai",
    "description": "Book Cheapest Cab Service in Powai for reliable local and long-distance transportation with transparent pricing and clean AC vehicles."
  }
],
"tableData": [
  ["Cheapest Cab Service in Mumbai", "Cheapest Taxi Service in Mumbai"],
  ["Cheapest Cab from Mumbai to Nashik", "Cheapest Cab in Mumbai"],
  ["Cheap Taxi in Mumbai", "Cheap Cabs Mumbai"],
  ["Cheap Taxi Mumbai", "Cheapest Cab from Pune to Mumbai Airport"],
  ["Cheapest Outstation Cabs from Mumbai", "Cheapest Cab Service in Mumbai Near Me"],
  ["Best Cheap Cab Service in Mumbai", "Cheapest Taxi Mumbai Contact Number"],
  ["Book Cheapest Cab in Mumbai Online", "Cheapest Cab Mumbai to Pune"],
  ["Cheapest Cab Mumbai Airport Pickup", "Cheapest Cab Service Mumbai 24x7"],
  ["Affordable Cab Service Mumbai for Family", "Cheap Cab Service Mumbai for Outstation"],
  ["Lowest Price Taxi Service in Mumbai", "Mumbai to 5 Jyotirlinga Darshan Cab"],
  ["Mumbai to Goa Cab", "Mumbai to Goa Taxi Fare"],
  ["Mumbai to Goa Taxi One Way Fare", "Mumbai to Goa Cab Price"],
  ["Cheapest Cab Service in Andheri", "Cheapest Cab Service in Navi Mumbai"],
  ["Cheapest Cab Service in Thane", "Cheapest Cab Service in Borivali"],
  ["Cheapest Cab Service in Dadar", "Cheapest Cab Service in Bandra"],
  ["Cheapest Cab Service in Kurla", "Cheapest Cab Service in Vashi"],
  ["Cheapest Cab Service in Panvel", "Cheapest Cab Service in Powai"]
],




whychoose: [
  {
    WhyChooseheading: "Budget-Friendly Cab Service in Mumbai",
    WhyChoosedescription: "Looking for an economical way to travel? Shreesha Travels offers affordable cab services in Mumbai with comfortable vehicles, professional chauffeurs, and transparent pricing for local and outstation journeys. Competitive per-kilometre pricing is common among many providers, though actual fares vary by vehicle type, distance, and trip details. "
  },
  {
    WhyChooseheading: "Affordable Travel Without Compromising Comfort",
    WhyChoosedescription: "Enjoy clean, air-conditioned vehicles, courteous drivers, and reliable transportation for airport transfers, business meetings, family outings, sightseeing, and daily travel while keeping your travel budget under control."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options at Competitive Prices",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to your travel requirements and budget."
  },
  {
    WhyChooseheading: "Affordable Local & Outstation Cab Booking",
    WhyChoosedescription: "Book economical taxi services for Mumbai city travel, airport transfers, one-way trips, round trips, corporate transportation, weekend holidays, and outstation destinations across Maharashtra and India."
  },
  {
    WhyChooseheading: "Flexible Booking Options for Every Journey",
    WhyChoosedescription: "Select hourly rentals, full-day packages, one-way transfers, round trips, or customized travel plans that fit your schedule and travel needs."
  },
  {
    WhyChooseheading: "Experienced Drivers for Safe & Smooth Travel",
    WhyChoosedescription: "Our professional chauffeurs know Mumbai city roads, expressways, and major highways, helping you reach your destination comfortably and on time."
  },
  {
    WhyChooseheading: "Well-Maintained Cars with Transparent Pricing",
    WhyChoosedescription: "Every vehicle is regularly serviced, sanitized, and inspected before every trip, while pricing is explained clearly before booking so you can travel with confidence."
  },
  {
    WhyChooseheading: "Book the Cheapest Cab Service in Mumbai with Shreesha Travels",
    WhyChoosedescription: "Choose Shreesha Travels for affordable taxi services, dependable chauffeur-driven vehicles, instant booking support, and comfortable travel across Mumbai and beyond."
  }
]

};

const faqData = [
  {
    question: "How can I get an affordable cab service in Mumbai?",
    answer: "Book your trip in advance, choose the right vehicle for your group size, and share complete travel details to receive the best available quotation."
  },
  {
    question: "Do you provide budget-friendly airport cab services?",
    answer: "Yes, we offer economical airport pickup and drop services for Mumbai Airport and Navi Mumbai Airport."
  },
  {
    question: "Which vehicles are available for affordable cab booking?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles."
  },
  {
    question: "Can I book a low-cost one-way cab from Mumbai?",
    answer: "Yes, one-way taxi services are available for both local and outstation destinations at competitive rates."
  },
  {
    question: "Do you offer affordable outstation taxi services?",
    answer: "Yes, we provide economical outstation cabs to Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Goa, Gujarat, Jaipur, Indore, and many other destinations."
  },
  {
    question: "Is corporate cab booking available at competitive prices?",
    answer: "Yes, we provide cost-effective transportation solutions for corporate travel, employee transfers, business meetings, and executive travel."
  },
  {
    question: "What factors affect the cab fare?",
    answer: "Cab fares depend on the selected vehicle, travel distance, trip duration, tolls, parking charges, waiting time, and travel itinerary."
  },
  {
    question: "Can I hire a cab for a full day at an affordable rate?",
    answer: "Yes, hourly rentals and full-day cab packages are available for sightseeing, personal travel, business visits, and family outings."
  },
  {
    question: "Are your cabs available 24x7 in Mumbai?",
    answer: "Yes, our taxi services are available throughout the day for advance and scheduled bookings."
  },
  {
    question: "How can I book the cheapest cab service in Mumbai with Shreesha Travels?",
    answer: "Share your pickup location, destination, travel date, passenger count, preferred vehicle, and trip type to receive a customized quotation and quick booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aniket Sharma",
    feedback: "We were looking for an affordable cab in Mumbai and Shreesha Travels offered a great balance of price, comfort, and professional service. The journey was smooth from start to finish.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Joshi",
    feedback: "Reasonable pricing, punctual pickup, and a clean vehicle made our trip enjoyable. It's a dependable option for anyone looking for value-for-money cab service in Mumbai.",
    rating: 5
  }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cheapest Cab Service in Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/cheapest-cab-service-in-mumbai.webp",
  "description":
    "Book Cheapest Cab Service in Mumbai with Shreesha Tours & Travels for affordable and reliable taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for local travel, airport transfers, outstation trips, Mumbai to Nashik journeys, Pune to Mumbai travel, family trips, business travel, and long-distance routes with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/cheapest-cab-service-in-mumbai"
  }
};





    return (
        <div>

<Helmet>
  <title>Cheapest Cab Service in Mumbai | Affordable Taxi Booking | +91 8355835813</title>

  <meta
    name="description"
    content="Book Cheapest Cab Service in Mumbai with Shreesha Travels for affordable and comfortable taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for local travel, airport transfers, Mumbai to Nashik, Pune to Mumbai, outstation trips, and 24x7 cab booking."
  />

  <meta
    name="keywords"
    content="Cheapest Cab Service in Mumbai, Cheapest Taxi Service in Mumbai, Cheapest Cab from Mumbai to Nasik, Cheapest Cab in Mumbai, Cheap Taxi in Mumbai, Cheap Cabs Mumbai, Cheap Taxi Mumbai, Cheapest Cab from Pune to Mumbai, Affordable Cab Service Mumbai, Low Cost Taxi Mumbai, Budget Cab Booking Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/94.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cheapestcabserviceinmumbai;